import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";

export function NotFoundPage() {
  return (
    <div className="container mx-auto px-6 py-24 text-center">
      <Seo title="Page Not Found" description="This page couldn't be found." path="/404" noindex />
      <img src="/assets/lgs-mark.png" alt="" className="mx-auto mb-6 h-28 w-28 opacity-90" />
      <h1 className="font-display text-4xl font-extrabold tracking-tight mb-4">404 — Page Not Found</h1>
      <p className="text-lg text-muted-foreground mb-8">
        Looks like this goose wandered off the path.
      </p>
      <Button asChild size="lg" className="rounded-full bg-ember text-ember-foreground hover:bg-ember/90">
        <Link to="/">Fly Back Home</Link>
      </Button>
    </div>
  );
}
